import { IconName } from '@infotech-soe/erp-ui-kit';

import {
  BuiltinCaptionType,
  Caption,
  CaptionType,
} from '../../../models/caption/Caption';
import CategoryCommandImpl from '../impl/CategoryCommandImpl';

import CategoryCommand from './CategoryCommand';

class SignCommand extends CategoryCommand<Record<string, unknown>> {
  constructor(
    commandImpl: CategoryCommandImpl<Record<string, any>>,
    private caption?: string
  ) {
    super(commandImpl);
  }
  public getIcon(): IconName {
    return 'sign';
  }

  public async getCaption(): Promise<Caption> {
    return this.caption
      ? {
          type: CaptionType.EXTERNAL,
          caption: this.caption,
        }
      : {
          type: CaptionType.BUILT_IN,
          caption: BuiltinCaptionType.SIGN,
        };
  }
}

export default SignCommand;
